import { Button, Tooltip, useTheme } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";
import { CUSTOM_RADII } from "Theme/Shape";
interface ChatButtonProps {
  Icon: SvgIconComponent;
  onClick?: () => void;
  backgroundColor?: string;
  hasBackground?: boolean;
  visibility?: boolean;
  tooltipTitle?: string;
  disabled?: boolean;
}

export const ChatButton = (props: ChatButtonProps) => {
  const { Icon, onClick, backgroundColor, hasBackground, visibility, tooltipTitle, disabled } = props;
  const theme = useTheme();
  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <Button
          disabled={disabled}
          variant="contained"
          sx={{
            zIndex: 10,
            width: "36px",
            height: "36px",
            borderRadius: CUSTOM_RADII.circle,
            minWidth: "30px",
            justifyContent: "center",
            alignItems: "center",
            visibility: visibility ? "hidden" : "visible",
            background: hasBackground ? backgroundColor : theme.palette.grey[100],
            color: theme.palette.grey[700],
            fontWeight: 600,
            "&:hover": {
              background: hasBackground ? theme.palette.grey[200] : theme.palette.grey[300],
            },
          }}
          onClick={onClick}
        >
          <Icon sx={{ width: "18px", height: "18px", display: "flex" }} />
        </Button>
      </span>
    </Tooltip>
  );
};
